import restApi from '../api/RestApi';
import { bankNumber, targetGroupId } from '../utils/constant';
import data from '../messages/msgData';
import Messages from '@messageformat/runtime/messages';

const messages = new Messages(data, 'fi');

messages.locale = (document.documentElement.getAttribute('lang') || 'fi')
.substring(0, 2)
.toLowerCase();

export const fetchPriceListContent = async (effectiveDate) => {
    const response = await restApi.getPricelistContents(bankNumber, targetGroupId, false, messages.locale, effectiveDate);
    return response;
};

export const fetchPriceList = async (pricelistId, effectiveDate) => {
    const response = await restApi.getPricelist(bankNumber, targetGroupId, pricelistId, false, messages.locale, effectiveDate);
    return response;
};

// Define effectiveDate in 'YYYY-MM-DD' format
const pingEffectiveDate = new Date().toISOString().split('T')[0];

// Function to ping the backend with parameters
const pingBackend = async (effectiveDate) => {
    await fetchPriceListContent(effectiveDate);
};

// Set interval to ping the backend every 4 minutes (240,000 milliseconds)
setInterval(() => pingBackend( pingEffectiveDate), 240000);

